import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { Tasks } from "@/pages/Tasks/Tasks";
import { TaskPage } from "@/pages/Tasks/TaskPage";

const LIST_PATH_PATTERN =
    /^(?:table(?:\/(?:open|closed|all))?|kanban(?:\/(?:open|closed|all))?|settings(?:\/sprints|\/statuses)?)?$/;
const DETAIL_PATH_PATTERN = /^\d+$/;

export const TasksRoutes: React.FC = () => {
    const path = (useParams()["*"] ?? "").replace(/\/+$/, "");

    if (LIST_PATH_PATTERN.test(path)) {
        return <Tasks />;
    }

    if (DETAIL_PATH_PATTERN.test(path)) {
        return <TaskPage taskId={path} />;
    }

    return <Navigate to="/tasks" replace />;
};

export { Tasks, TaskPage };
